import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { colors } from 'src/themes/colors';
import { mediaQuery } from 'src/themes/breakpoints';

const StyledBurger = styled.button<BurgerProps>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: none;
  flex-direction: column;
  height: 17px;
  justify-content: space-between;
  padding: 0;
  width: 42px;
  z-index: 2;

  &:focus:not(:focus-visible) {
    outline: 0;
  }

  ${mediaQuery('md', 'max')} {
    display: flex;
  } ;
`;

const Line = styled.span<BurgerProps>`
  background-color: ${props =>
    props.isDark ? `${colors.blue}` : `${colors.grey100}`};
  border-radius: 2px;
  height: 1px;
  transform-origin: left center;
  transition: transform 0.3s ease;
  width: 32px;
  z-index: 2;

  ${({ isOpen }) =>
    isOpen &&
    css`
      background-color: ${colors.grey100};
    `}

  &:first-of-type {
    transform: ${props =>
      props.isOpen ? 'rotate(45deg) translate3d(-2px, 0, 0)' : 'none'};
  }

  &:nth-of-type(2) {
    transform: ${props =>
      props.isOpen ? 'rotate(-45deg) translate3d(-11px, 7px, 0);' : 'none'};
    transition-delay: 150ms;
  }

  &:last-of-type {
    opacity: ${props => (props.isOpen ? '0' : '1')};
    transition-delay: 300ms;
  }
`;

interface BurgerProps {
  isOpen?: boolean;
  isDark?: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const Burger: FC<BurgerProps> = ({ isOpen, isDark, setIsOpen }) => (
  <StyledBurger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
    <Line isOpen={isOpen} isDark={isDark} />
    <Line isOpen={isOpen} isDark={isDark} />
    <Line isOpen={isOpen} isDark={isDark} />
  </StyledBurger>
);

export default Burger;
